module.exports = __webpack_public_path__ + "img/texture-brick-2-top-birthday.f44c7225.jpg";